import React from 'react'

function SponsorProfile() {
  return (
    <div>SponsorProfile</div>
  )
}

export default SponsorProfile